module.exports = __webpack_public_path__ + "img/scroll.1a3f89d9.svg";